import { useCallback, useContext } from "react"

import { PageTitleContext } from "./context"

type UseSetPageTitle = () => {
  setPageTitle: (title: string | undefined) => void
}

export const useSetPageTitle: UseSetPageTitle = () => {
  const context = useContext(PageTitleContext)

  if (!context) {
    throw new Error("useSetPageTitle should be invoked inside PageTitleContextProvider")
  }

  const { setNewPageTitle } = context

  const setPageTitle = useCallback(
    (title) => {
      setNewPageTitle(title)
    },
    [setNewPageTitle],
  )

  return {
    setPageTitle,
  }
}
